import { render, staticRenderFns } from "./Videotag.vue?vue&type=template&id=7905c9e8&"
import script from "./Videotag.vue?vue&type=script&lang=js&"
export * from "./Videotag.vue?vue&type=script&lang=js&"
import style0 from "./Videotag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports